<template>
  <v-menu offset-y nudge-top="-10" max-height="25rem" light>
    <template v-slot:activator="{ on }">
      <v-btn @click="clickCart" icon class="mr-6" x-large dark v-on="on">
        <img src="/assets/ic/header/ic_header_cart_white.svg" alt="cart icon" />
      </v-btn>
    </template>
    <v-list>
      <v-list-item v-if="!isLogin">
        <v-list-item-title>
          {{ $t("nav.notLogin") }}
        </v-list-item-title>
      </v-list-item>
      <div v-else style="width: 20rem;">
        <v-subheader>{{ $t("cart.myCart") }}</v-subheader>
        <v-divider></v-divider>
        <v-list-item
          v-for="(item, idx) in cart.slice(0, 4)"
          :key="'topCart' + idx"
          class="mt-3"
        >
          <div class="d-flex ai-center w-100">
            <div class="d-flex flex-column preview-img mr-2">
              <div class="flex-1">
                <v-img
                  max-height="1.2rem"
                  :src="getStaticFileURL(item.tag.imgPath)"
                  contain
                ></v-img>
              </div>
              <div class="flex-1">
                <v-img
                  max-height="1.2rem"
                  :src="item.previewImg"
                  contain
                ></v-img>
              </div>
            </div>
            <div class="flex-1 d-flex flex-column al-stretch jc-between">
              <div>
                {{ item.tag.name }}
              </div>
              <div class="d-flex" style="font-size: 0.7rem">
                <span class="mr-5">
                  {{ $t("cart.unitPrice") }}: {{ unitPrice(item) }}
                </span>
                <span> {{ $t("cart.amount") }}: {{ item.saleVolume }} </span>
              </div>
            </div>
          </div>
        </v-list-item>
        <v-list-item class="d-flex jc-center" v-if="cartLoading">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-list-item>
        <v-list-item v-else-if="cart.length > 0" class="d-flex jc-center mt-3">
          <div>
            <v-btn
              :to="`/${this.$i18n.locale}/order/cart`"
              depressed
              outlined
              color="orange"
            >
              {{ $t("cart.viewAll") }}
            </v-btn>
          </div>
        </v-list-item>
      </div>
    </v-list>
  </v-menu>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  computed: {
    ...mapState("user", ["isLogin"]),
    ...mapState("cart", ["cartLoading", "cart"])
  },
  methods: {
    ...mapActions("cart", ["getCart"]),
    unitPrice(item) {
      const amount = item.amount;
      const pr = item.tag.priceRanges;
      const len = item.tag.priceRanges.length;
      for (let i = 0; i < len; i++) {
        if (amount >= pr[i].interval) return pr[i].price;
      }
      return item.tag.priceRanges[len - 1].price;
    },
    async clickCart() {
      if (!this.isLogin) return;
      await this.getCart();
    }
  }
};
</script>

<style lang="sass" scoped>
.preview-img
  width: 2.6rem
  height: 2.6rem
  background: #f8f8f8
  border-radius: 0.2rem
  padding: 0.1rem

.nav-icon
  width: 2.5rem
  &.icon-avatar
    width: 3rem
    height: 3rem
  g
    transition: ease-in-out 0.2s
    stroke: white
  &:hover
    g
      stroke: white
</style>
